/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media only screen and (min-width:600px) and (max-width:960px){.cards-wrapper[_ngcontent-%COMP%]   ads-card[_ngcontent-%COMP%]{margin-right:1%;margin-left:1%}}"];
export { styles as styles };
